import React from 'react';
import { Link } from 'react-router-dom';
import  SimpleReactValidator from 'simple-react-validator';
import Preloader from '../../../core/Preloader';
import { viewData, processData } from '../../../core/HttpAction';
import {permissionCheck} from '../../../core/Permission';
import Nopermission from '../../../core/Nopermission';
const Url='/course';
const backUrl='/department'+Url;
 

class AddEditAction extends React.Component {
    constructor(props) {
        super(props); 
        this.state={
            course_name:'', 
            course_duration:'', 
            preloader:this.props.match.params.id?true:false,
            title:this.props.match.params.id?'Edit':'New'
        };
        this.validator = new SimpleReactValidator();
    }


    componentDidMount(){
        if(this.props.match.params.id){
            viewData(Url+'/'+this.props.match.params.id).then((res)=>{
                if(res.data.status===200){
                    let data=res.data.data;
                    this.setState({
                        course_name:data.course_name?data.course_name:'', 
                        course_duration:data.course_duration?data.course_duration:'', 
                        preloader:false, 
                    });
                }
            });
        }
    }
 
    setStateFromInput=(event)=> {
        var obj = {};
        obj[event.target.name] = event.target.value;
        this.setState(obj);
    }

    submitForm=()=>{
        if( this.validator.allValid() ){
            let params={
                course_name:this.state.course_name,
                course_duration:this.state.course_duration,
            };
            let para=this.props.match.params.id?'/'+this.props.match.params.id:'';
            processData(Url+para,params).then((res)=>{
                if(res.data.status===200){
                    this.props.history.push(backUrl);
                } else{
                    const msg =res.data.message?res.data.message:'Please enter required feilds...';                     alert(msg);
                    this.setState({error_status:true,preloader:false});
                }
            });
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    }
 
  
    render() {
        let {title,preloader,course_name,course_duration} = this.state;
        let role=permissionCheck('course',title);
        if(!role)
            return <Nopermission/>;
        const course_nameValid= this.validator.message('Course',course_name, 'required');
        const course_durationValid= this.validator.message('Course Duration',course_duration, 'required|numeric');
        return (
            <div id="page_content_inner" className="uk-width-medium-4-10 uk-container-center">
                <h3 className="heading_b uk-margin-bottom">{title} Course</h3>
                <div className="md-card">
                    <div className="md-card-content large-padding">
                        <div className="uk-grid" data-uk-grid-margin>
                            <div className="uk-width-medium-1-1"> 
                                <div className={ `md-input-wrapper ${course_name ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="name">Course<span className="req">*</span></label>
                                    <input type="text" name="course_name" value={course_name} onChange={this.setStateFromInput} className={ `md-input ${course_nameValid ?'md-input-danger':''}`} /> 
                                    {course_nameValid} 
                                </div>
                            </div>
                        </div>

                        <div className="uk-grid" data-uk-grid-margin>
                            <div className="uk-width-medium-1-1"> 
                                <div className={ `md-input-wrapper ${course_duration ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="Course Duration">Course Duration<span className="req">*</span></label>
                                    <input type="text" name="course_duration" value={course_duration} onChange={this.setStateFromInput} className={ `md-input ${course_durationValid ?'md-input-danger':''}`} /> 
                                    {course_durationValid} 
                                </div>
                            </div>
                        </div>
                        
                        <div className="uk-grid">
                            <div className="uk-width-1-1">
                                <Link to={backUrl} className="md-btn md-btn-danger md-btn-wave-light waves-effect waves-button waves-light">Cancel</Link>
                                <button type="button" onClick={this.submitForm} className="md-btn md-btn-primary md-btn-wave-light waves-effect waves-button waves-light">Submit</button>
                            </div>
                        </div>
                    </div>
                </div>
                { preloader && <Preloader/> }
            </div>  
        );
    }
}
 

export default AddEditAction;


// WEBPACK FOOTER //
// ./src/components/Department/Course/addEdit.js